import { FadeTransition } from 'vue2-transitions';
import inputMixin from '../../utils/mixins/inputMixin.js';

//
var script = {
  name: 'TextareaControl',
  components: {
    FadeTransition: FadeTransition
  },
  mixins: [inputMixin],
  computed: {
    rootClass: function rootClass() {
      return {
        '_success': this.isValidDI && !this.isErrorDI,
        '_error': this.isErrorDI,
        '_focus': this.focused,
        '_disabled': this.disabled,
        '_hover': this.hovering
      };
    }

  }
};

export default script;
